

























































import { Component, Mixins, Prop } from 'vue-property-decorator'
import OzRichDesktopModal from 'library/v4/components/-oz-rich-desktop-modal.vue'
import OzButton, { OzButtonColorScheme } from 'library/v4/components/OzButton.vue'

export interface OzBaseDialogButtonData {
  text: string
  emit: string
  colorScheme: OzButtonColorScheme
  testId?: string
}

@Component({ components: { OzRichDesktopModal, OzButton } })
export default class OzBaseDialog extends Mixins() {
  /**
   * Tailwind width class.
   * 'w-89.5' for mobile comment editor
   * 'w-82' for desktop
   * 'w-72' for mobile
   */
  @Prop({ default: 'w-72' }) widthClass!: 'w-89.5' | 'w-82' | 'w-72'

  /**
   * List of data to generate buttons.
   */
  @Prop() buttons!: OzBaseDialogButtonData[]

  /**
   * Determines if each button should fill the width of the dialog
   */
  @Prop({ default: false }) forceFullWidthButtons!: boolean

  /**
   * Determines whether we should compute a fix height for the dialog
   */
  @Prop({ default: true }) shouldFixHeight!: boolean

  select(buttonEvent): void {
    /**
     * Emits events passed in via the `buttons` prop.
     * @event buttonEvent
     */
    this.$emit(buttonEvent)
  }

  cancel(): void {
    /**
     * Emitted when user tries to close the dialog.
     */
    this.$emit('cancel')
  }
}

export { OzButtonColorScheme }
